import React, { useState, useEffect } from 'react';
//Components
import EditarEmail from './EditarEmail';
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
//Api
import email_api from '../../../api/email_api';
//Helpers
import { showMessage } from '../../../helpers/message';

//Actions
import { actionsTable } from '../../../constants/MaterialTable';

export default function Emails({ permissao }) {
    //Guarda a lista dos email
    const [emails, setEmails] = useState([]);
    //Controla o loading na tela
    const [loading, setLoading] = useState(false);
    //Controle a tela de edição de email na tela
    const [editarEmail, setEditarEmail] = useState(null);
    //Função de clique para o botão de editar email
    const editar = (item) => setEditarEmail(item.id);
    //Função de clique para o botão de voltar
    const btnVoltar = () => setEditarEmail(null);
    //Carrega a lista de emails ao inicializar a tela
    useEffect(() => {
        setLoading(true);
        email_api.GetList().then(response => {
            setEmails(response.data)
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error");
            setLoading(false);
        });
    }, []);
    //Cabeçalhos da tabela de emails
    const headers = [
        { value: "Finalidade", objectValue: "finalidade", align: "left" }
    ]
    //Variavel que guarda as ações da tabela 
    const actions = [];
    if (permissao == "Editar") {
        actions.push(actionsTable.editar(editar))
    }
    //Controle da tela de editar na tela
    if (editarEmail != null) {
        return <EditarEmail id={editarEmail} loading={loading} setLoading={setLoading} btnVoltar={btnVoltar} />
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de emails"} options={{ print: false, search: true, pagination: true }} headers={headers} items={emails} />
                </div>
            </MainCard>
        </>
    )
}